<template>
    <div class="row">
        <div class="col-12 mb-4">
            <h1 class="mb-0">{{ $t('generator-settings') }}</h1>
        </div>
        <div class="col-12 col-lg-5 col-xl-6 mb-4">
            <div class="list-group border-radius-2 no-border">
                <div class="list-group-item font-weight-bold text-sm">{{ $t('student-groupings') }}</div>
                <div
                    v-for="type in groupTypes"
                    :key="type.id"
                    class="list-group-item d-flex flex-row justify-content-between align-items-center"
                    :class="{'bg-light': selectedType && (type.id === selectedType.id) }"
                    @click="selectGroupType(type)"
                >
                    {{ type.title }}
                    <b-icon icon="chevron-right" class="d-none d-lg-block" />
                    <b-icon icon="chevron-down" class="d-block d-lg-none" />
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-7 col-xl-6 mb-4">
            <div class="list-group border-radius-2 no-border">
                <div class="list-group-item font-weight-bold text-sm">{{ $t('groups') }}</div>

                <YearGroupRow 
                    v-for="year in Object.keys(groupsByYear)" 
                    :key="year"
                    :year="year"
                    :groups="groupsByYear[year]"
                    :editable="false"
                    :slim="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import YearGroupRow from "src/components/GroupTypes/YearGroupRow.vue"

export default {
    components: {
        YearGroupRow,
    },
    mounted() {
        this.fetchGroupTypes().then(() => {
            this.loading = false
        })
    },
    data() {
        return {
            loading: true,
            groupTypes: [],
            selectedType: null,
            new_type: {
                title: '',
            },
            groups: [],
            groupsByYear: {},
        }
    },
    methods: {
        fetchGroupTypes() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/grouptypes/all`, {
                method: 'GET'
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching group types')

                this.groupTypes = res.results
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-group-types')
                })
            })
        },
        selectGroupType(type) {
            if (this.selectedType && this.selectedType.id === type.id) return

            this.selectedType = type
            this.fetchGroups()
        },
        fetchGroups() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/grouptypes/yeargroups/all`, {
                method: 'GET',
                data: { grouptype_id: this.selectedType.id },
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching groups')

                this.groups = res.results
                this.groupsByYear = this.groups.reduce((prev, curr) => {
                    if (!prev[curr.year]) prev[curr.year] = []
                    prev[curr.year].push(curr)
                    return prev
                }, {})
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-groups')
                })
            })
        },
        saveGroupType(type) {
            return this.$cfetch(`${this.$settings.APIBaseURL}/grouptypes/save`, {
                method: 'POST',
                data: {
                    id: type.id ? type.id : undefined,
                    title: type.title,
                }
            })
        }
    },
}
</script>